import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrPlaysByAdResponse } from '@/api/routes/stat/types';

import { fetchAggrPlaysByAd } from './actionCreators';

interface InitialState {
  playsByAd: AggrPlaysByAdResponse,
  prevPlaysByAd: AggrPlaysByAdResponse,
  selectedAds: string[],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  playsByAd: {},
  prevPlaysByAd: {},
  selectedAds: [],
  isLoading: false,
  error: '',
};

export const aggrPlaysByAdSlice = createSlice({
  name: 'aggrPlaysByAd',
  initialState,
  reducers: {
    selectAds: (state, action: PayloadAction<string[]>) => {
      state.selectedAds = action.payload;
    },
  },
  extraReducers: {
    [fetchAggrPlaysByAd.fulfilled.type]: (state, action: PayloadAction<AggrPlaysByAdResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.prevPlaysByAd = state.playsByAd;
      state.playsByAd = action.payload;
    },
    [fetchAggrPlaysByAd.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrPlaysByAd.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { selectAds } = aggrPlaysByAdSlice.actions;
export default aggrPlaysByAdSlice.reducer;
